import React from 'react'
import SideNav from './SideNav'

const DecorativeUnitsDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-decorative-units-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Decorative Units Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/decorative-units-design.jpg" alt="Decorative Units Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Decorative units give interiors their final character. At <b>MeHome</b>, 
                      we craft designs that balance style, structure, and substance — 
                      making every corner of your home expressive and refined.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Bringing <span>Design & Detail Together</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Our decorative units are not just visually appealing — they are designed 
                      to serve practical needs while accentuating your interior themes. 
                      From living rooms to hallways, each design element is handpicked and precisely built.
                    </p>

                    <ul>
                      <li>Custom-designed wall and display units for every room.</li>
                      <li>Smart storage integration within decorative setups.</li>
                      <li>Wide material choices including wood, glass, and textured laminates.</li>
                      <li>Lighting elements that highlight focal points beautifully.</li>
                      <li>Minimal, contemporary, or traditional design styles available.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Custom <span> Decorative Creations</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">📺</div>
                        <div className="why-choose-item-content">
                          <h3>TV & Media Units</h3>
                          <p>
                            Elegant and functional entertainment walls that define the living space 
                            while keeping wires and accessories neatly concealed.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🍷</div>
                        <div className="why-choose-item-content">
                          <h3>Bar & Display Cabinets</h3>
                          <p>
                            Compact yet striking bar setups and crockery displays 
                            designed to complement your dining and social spaces.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">📚</div>
                        <div className="why-choose-item-content">
                          <h3>Bookshelves & Niche Units</h3>
                          <p>
                            Customized shelving and wall niches that add structure and character 
                            while providing ample space for decor or reading collections.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🏡</div>
                        <div className="why-choose-item-content">
                          <h3>Entry Consoles & Accent Walls</h3>
                          <p>
                            Stylish entry tables and wall units that create an inviting first impression 
                            with fine detailing and premium finishes.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Lighting-Integrated Decor</h3>
                          <p>
                            Decorative units featuring ambient backlighting or spotlighting 
                            to enhance textures, depth, and dimension across your interiors.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
 

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Clients Trust <span> MeHome’s Design Craft</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Exclusive Concepts:</b> Every piece designed to complement your interiors.</li>
                        <li><b>Refined Materials:</b> High-quality finishes that endure time and trends.</li>
                        <li><b>Functional Detailing:</b> Every unit serves both beauty and purpose.</li>
                        <li><b>Holistic Approach:</b> Coordination with lighting, layout, and decor themes.</li>
                        <li><b>Precision Delivery:</b> Flawless execution handled by experts.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default DecorativeUnitsDesigns
